import { useEffect, useRef, useState } from "react";
import userInfoStore, { getUser } from "@/store/user.store";
import ItemGrid from "../components/RecordItem/ItemGrid";
import ItemStrip from "../components/RecordItem/ItemStrip";
import { Loading, LoadMore } from "@/component/Loading";
import IC_AI from "@/assets/record/ic_ai.svg?react";
import IC_GRID_LAYOUT from "@/assets/record/ic_grid_layout.svg?react";
import IC_STRIP_LAYOUT from "@/assets/record/ic_strip_layout.svg?react";
import IC_CLEAR from "@/assets/record/ic_clear.svg?react";
import IC_ADD from "@/assets/record/ic_add.svg?react";
import IC_SEARCH from "@/assets/record/ic_search.svg?react";
import IC_NODE from "@/assets/record/ic_none.png";
import IC_RETRY from "@/assets/record/ic_retry.svg?react";
import { IOptions } from "@/component/Select";
import { SimpleRecord, getRecordList } from "@/services/api_list";
import { debounce } from "../../../../../utils/common";
import MeetingHandler from "@/bussiness/MeetingHandler";
import EasyLoading from "@/component/EasyLoading";
import DebugView from "../components/DebugView";
import { RuningInLink, SURPORT_MODEL_ID } from "@/constants";
import User from "@/sections/User";
import IC_HOME_SEARCH from "@/assets/common/ic_search.svg?react";
import useLoginStore from "@/store/login.store";
import ReactDOM from "react-dom";
import HeaderVoice from "@/layout/HeaderVoice";
import './index.css';
import fridayReporter from '@/utils/friday';
import AudioImport from "@/pages/Home/components/AudioImport/index";
import UploadStation from "@/pages/Home/components/UploadStation";
import eventBus from "@/utils/event";
import { message } from "antd";
import appStore from "@/store/app.store";
import LinkFlow from "@/sections/LinkFlow";
import { IS_PRIVATE } from "@/config";
import ControlPopover from "../components/ControlPopover";
import { handleStartRecording } from "@/utils/recordingHandler";
import timingStore from "@/store/timing.store";
import { useNavigate } from "react-router-dom";

const meetingGirdLayoutKey = "meetingGirdLayoutKey";
let page = 0; // 页码

let repeatClickCount = 0; // 五秒内点击 8 次可打开后门
let timer: NodeJS.Timeout | number | null;

export default function WebHome() {
  const navigate = useNavigate();
  const cateCategoryList: Array<IOptions> = [
    { id: "RECENT", label: "最近", show: true },
    { id: "SHARE_FOR_ME", label: "与我分享", show: !IS_PRIVATE },
    { id: "COLLECT", label: "收藏", show: true },
  ];
  const asrModelId = appStore((state) => state.asrModelId);

  const searchText = useRef("");
  const [showDebug, setShowDebug] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cateCategory, setCateCategory] = useState("RECENT");
  const [list, setList] = useState<Array<SimpleRecord>>([]);
  const isLoadMore = useRef(false); // 是否正在加载更多
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [showLoadEnd, setShowLoadEnd] = useState(false);
  const [showFlow, setShowFlow] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const lastLoadErrorFn = useRef<(() => void) | null>(null);
  const [girdLayout, setMyGirdLayout] = useState(
    localStorage.getItem(meetingGirdLayoutKey) === undefined || localStorage.getItem(meetingGirdLayoutKey) === null ? true : localStorage.getItem(meetingGirdLayoutKey) === "true"
  );
  const startLoading = timingStore((state) => state.startLoading);

  const setGirdLayout = (newValue: boolean) => {
    setMyGirdLayout(newValue);
    localStorage.setItem(meetingGirdLayoutKey, newValue.toString());
  };

  const hasLogin = useLoginStore((state) => state.hasLogin);

  const ref = useRef<HTMLDivElement>(null);

  const refInput = useRef<HTMLInputElement>(null);

  const isWindows = navigator.platform.indexOf("Win") !== -1;

  useEffect(() => {
    page = 0;
    loadList({ type: cateCategory, isFirst: true });
    eventBus.on('refresh', (fileName) => {
      page = 0;
      message.success(`${fileName}转写成功`);
      loadList({ type: cateCategory, isFirst: true });
    });
    getUser();
    console.log(`width = ${screen.width} height = ${screen.height}`);
    return (() => {
      eventBus.removeAllListeners();
    });
  }, []);

  const onSearchInput = (content: string) => {
    setShowClear(content != "");
    if (searchText.current === content) return;
    searchText.current = content;
    page = 0;
    loadList({ type: cateCategory });
  };

  const clearHandle = () => {
    refInput.current && (refInput.current.value = "");
    searchText.current = "";
    setShowClear(false);
    page = 0;
    loadList({ type: cateCategory });
  };

  const choseCategory = (value: IOptions) => {
    switch (value.id) {
      case "RECENT":
        fridayReporter.pushData({
          eventCode: "HomePage_ListFiltrate_Recent",
        });
        break;
      case "SHARE_FOR_ME":
        fridayReporter.pushData({
          eventCode: "HomePage_ListFiltrate_Share",
        });
        break;
      case "COLLECT":
        fridayReporter.pushData({
          eventCode: "HomePage_ListFiltrate_Favorite",
        });
        break;

      default:
        break;
    }
    page = 0;
    loadList({
      type: value.id,
      handle: () => {
        setCateCategory(value.id);
      },
    });
  };

  const loadListFn = (prop: { type: string; isFirst?: boolean; handle?: () => void }) => {
    setLoadError(false);
    if (!isLoadMore.current) setIsLoading(true);
    getRecordList(false, prop.type, page, encodeURIComponent(searchText.current))
      .then((res) => {
        if (res.empty && prop.isFirst) {
          userInfoStore.getState().updateRecordFlag(true);
        } else {
          setList(page === 1 ? res.data : list.concat(res.data));
          userInfoStore.getState().updateRecordFlag(false);
          if (res.pageIndex >= res.totalPages) {
            setShowLoadEnd(true);
            console.log("当前页数==总页数");
          }
        }
        if (!isLoadMore.current) setIsLoading(false);
        prop.handle?.();
      })
      .catch((e) => {
        setLoadError(true);
        lastLoadErrorFn.current = () => {
          page = 1;
          isLoadMore.current = false;
          loadListFn({ ...prop });
        };
        console.log("列表加载错误", e);
      });
  };

  const loadList = (prop: { type: string; isFirst?: boolean; handle?: () => void }) => {
    if (page === 0) {
      setList([]);
      setShowLoadEnd(false);
    }
    page++;
    loadListFn(prop);
  };

  // 使用 streamName 作为唯一标识，避免索引导致的问题
  const deleteCallback = (streamName: string) => {
    setList((prevList) => prevList.filter((item) => item.streamName !== streamName));
  };

  // 在收藏面板取消收藏才会将其在列表中删除, 否则只隐藏收藏标签
  const cancelCollectCallback = (model: SimpleRecord) => {
    if (cateCategory === 'COLLECT') {
      setList((prevList) => prevList.filter((item) => item.streamName !== model.streamName));
    } else {
      setList((prevList) =>
        prevList.map((item) =>
          item.streamName === model.streamName ? model : item
        )
      );
    }
  };

  const handleCallback = (model: SimpleRecord) => {
    setList((prevList) =>
      prevList.map((item) =>
        item.streamName === model.streamName ? model : item
      )
    );
  };

  const onListScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const scrollTop = e.currentTarget.scrollTop; // 距顶部
    const clientHeight = e.currentTarget.clientHeight; // 可视区高度
    const scrollHeight = e.currentTarget.scrollHeight; // 滚动条总高度
    if (!isLoadMore.current && scrollTop + clientHeight + 40 >= scrollHeight) {
      if (showLoadEnd) {
        console.log("已经加载完毕，无需再次加载");
      } else {
        isLoadMore.current = true;
        setShowLoadMore(true);
        loadList({
          type: cateCategory,
          handle: () => {
            isLoadMore.current = false;
            setShowLoadMore(false);
          },
        });
      }
    }
  };

  const openDebug = async () => {
    if (timer != null) {
      repeatClickCount++;
      if (repeatClickCount === 8) {
        setShowDebug(true);
        repeatClickCount = 0;
        timer && clearTimeout(timer);
        timer = null;
      }
    } else {
      timer = setTimeout(() => {
        repeatClickCount = 0;
        timer && clearTimeout(timer);
        timer = null;
      }, 5000);
    }
  };

  const [showSearch, setShowSearch] = useState(false);

  const handleShowSearch = () => {
    fridayReporter.pushData({
      eventCode: 'HomePage_Search'
    })
    setShowSearch(true);
  }

  const handleHideSearch = () => {
    clearHandle();
    setShowSearch(false);
  }

  const handleSearchBlur = () => {
    if (!refInput.current?.value) {
      handleHideSearch();
    }
  }

  const buildSearch = () => {
    const homeSearch = document.getElementById("home-search");
    if (!homeSearch) return;
    return ReactDOM.createPortal(
      showSearch ? (
        <div className="w-62.5 h-8 rd-2 border-solid border-1 border-#4981F2 flex flex-items-center pl-3 pr-2 m-r-4.5 bg-#fff">
          <IC_SEARCH className="w-4 h-4 mr-2" />
          <input
            ref={refInput}
            className="flex-1 border-0 bg-transparent focus:outline-none h-6 placeholder:text-mx-quaternary"
            placeholder="搜索记录"
            autoFocus
            onChange={debounce((e) => {
              onSearchInput(
                (e as React.ChangeEvent<HTMLInputElement>).target.value
              );
            }, 500)}
            onBlur={handleSearchBlur}
          ></input>
          <IC_CLEAR
            className="w-4 h-4 cursor-pointer"
            onClick={handleHideSearch}
          />
        </div>
      ) : (
        <IC_HOME_SEARCH
          className="w-8 h-8 mr-6 cursor-pointer flex items-center"
          onClick={handleShowSearch}
        ></IC_HOME_SEARCH>
      ),
      homeSearch
    );
  };


  const buildActionBar = () => {
    return (
      <div className="h-10 w-full mt-2 flex flex-items-center text-mx-tertiary text-size-3.5 px-6">
        <div
          className="flex-1 flex flex-items-center relative cursor-pointer"
          ref={ref}
        >
          {cateCategoryList.map((item) => {
            if (!item.show) return null;
            return (
              <div
                key={item.id}
                className={`w-18 py-2 text-3.5 mr-4 rounded-2.5 text-center ${cateCategory === item.id
                  ? "bg-#191D26/4 text-mx-secondary"
                  : "text-mx-tertiary"
                  }`}
                onClick={() => choseCategory(item)}
              >
                {item.label}
              </div>
            );
          })}
        </div>
        {!girdLayout && !!list.length && <div className="w-30 mr-12">来源</div>}
        {!girdLayout && !!list.length && <div className="w-25 mr-12">创建时间</div>}
        {!girdLayout && !!list.length && <div className="w-15 mr-12">时长</div>}
        {girdLayout ? (
          <IC_STRIP_LAYOUT
            className="w-8 h-8 mr-6 cursor-pointer"
            onClick={() => {
              fridayReporter.pushData({
                eventCode: 'HomePage_ListView'
              })
              setGirdLayout(!girdLayout);
            }}
          />
        ) : (
          <IC_GRID_LAYOUT
            className="w-8 h-8 mr-6 cursor-pointer"
            onClick={() => {
              fridayReporter.pushData({
                eventCode: 'HomePage_CardView'
              })
              setGirdLayout(!girdLayout);
            }}
          />
        )}
      </div>
    );
  };

  const buildButton = () => {
    return (
      <div className="flex">
        {!IS_PRIVATE &&
          <div className="flex mr-4 flex-items-center flex-justify-center h-9.5 bg-#383B50 rd-2.5 px-3.5 cursor-pointer" onClick={() => handleStartRecording()}>
            <IC_ADD className="w-4.5 h-4.5" />
            <span className="text-white text-size-3.5 ml-1">新建录音</span>
          </div>
        }
        {!IS_PRIVATE && <AudioImport />}
        {<ControlPopover onControl={handleControl} onSync={linkHandle} />}
      </div >
    );
  };

  const handleRetry = () => {
    if (lastLoadErrorFn.current) {
      lastLoadErrorFn.current();
      lastLoadErrorFn.current = null;
    }
  };


  const handleControl = () => {
    navigate("/simulInter");
  }

  const linkHandle = async () => {
    if (!isWindows) {
      console.log("申请位置权限然后开始传输");
      await MeetingHandler.requestLocation();
      setTimeout(async () => {
        // 获取位置权限
        const check = await MeetingHandler.checkLocation();
        if (!check) {
          message.warning("开启定位权限，体验一键连接附近设备");
          if (MeetingHandler.isRequested()) MeetingHandler.openLocationSetting();
          return;
        } else {
          console.log("已允许定位权限检测");
        }
        setShowFlow(!showFlow);
      }, 200);
    } else {
      setShowFlow(!showFlow);
    }
  };
  const closeLink = () => {
    setShowFlow(!showFlow);
  }

  useEffect(() => {
    const checkAndLoadMore = () => {
      const container = document.querySelector('.my-scrollbar');
      if (container) {
        const { scrollHeight, clientHeight } = container;
        if (scrollHeight <= clientHeight && !showLoadEnd && !isLoadMore.current) {
          console.log('列表高度<=屏幕高度，自动加载下一页');
          isLoadMore.current = true;
          setShowLoadMore(true);
          loadList({
            type: cateCategory,
            handle: () => {
              isLoadMore.current = false;
              setShowLoadMore(false);
            },
          });
        } else {
          console.log('列表高度>屏幕高度，无需自动加载下一页');
        }
      }
    };

    // 在列表数据更新后检查
    if (!isLoading && !loadError && list.length > 0) {
      checkAndLoadMore();
    }
  }, [list, isLoading, loadError]);

  return (
    <div className="w-full h-full flex flex-col relative">
      {!IS_PRIVATE && <UploadStation />}
      {showFlow && <LinkFlow onClose={closeLink} />}
      <EasyLoading isShow={startLoading}></EasyLoading>
      <DebugView
        isOpen={showDebug}
        onClose={() => {
          setShowDebug(false);
        }}
      ></DebugView>
      <div className="h-16 mt-4 flex flex-row flex-items-center px-6">
        <IC_AI className="w-12 h-12" onClick={openDebug}></IC_AI>
        <span className="ml-1 text-mx-secondary fw-500 text-size-5">AI 会记</span>
        {!IS_PRIVATE && <div className="ml-2 bg-#5698FF1A rounded-1 text-color-#5698FF text-size-3 px-1.5 py-0.4">限免</div>}
        <div className="flex-1 flex justify-end flex-items-center">
          {buildSearch()}
        </div>
        {!showSearch && buildButton()}
        {!RuningInLink && hasLogin && (
          <div className="ml-6 flex items-center">
            <div id="home-search" />
            {asrModelId === SURPORT_MODEL_ID.TencentLarge && <HeaderVoice />}
            <div className="w-.25 h-6 bg-#DBDEE4 mr-6"></div>
            <User />
          </div>
        )}
      </div>
      {isLoading && !loadError && (
        <div className="flex-1 flex flex-items-center flex-justify-center absolute top-50% left-50% translate-x--50% translate-y--50%">
          <Loading />
        </div>
      )}
      {loadError && (
        <div className="flex flex-col flex-justify-center flex-items-center flex-1 absolute top-50% left-50% translate-x--50% translate-y--50%">
          <IC_RETRY className="w-20 h-20" />
          <span className="mt-1 text-mx-quaternary text-3.5">加载超时</span>
          <div className="mt-4 b-1 border-solid b-#DBDEE4 w-22 h-8 rounded-1.5 flex justify-center items-center text-mx-secondary text-3.5 cursor-pointer" onClick={handleRetry}>
            重试
          </div>
        </div>
      )}
      {!isLoading && !loadError && buildActionBar()}
      {!isLoading &&
        !loadError &&
        (list.length === 0 ? (
          <div className="flex flex-col flex-justify-center flex-items-center flex-1 absolute top-50% left-50% translate-x--50% translate-y--50%">
            <img src={IC_NODE} className="w-20 h-20" />
            <span className="mt-1 text-mx-quaternary text-3.5">{showClear ? "没有找到搜索内容" : "暂无会议记录"}</span>
          </div>
        ) : girdLayout ? (
          <div
            className="flex flex-col flex-1 mt-2 pt-2 overflow-y-auto my-scrollbar pl-6 mr-1.5"
            onScroll={(e) => {
              onListScroll(e);
            }}
          >
            <div className="w-full mb-6 gridContainer pr-3">
              {list.map((m) => (
                <ItemGrid
                  isDeleted={m.isDeleted || m.subscribed === false}
                  model={m}
                  deleteCallback={() => {
                    deleteCallback(m.streamName);
                  }}
                  cancelCollectCallback={(model) => {
                    cancelCollectCallback(model);
                  }}
                  handleCallback={(model) => {
                    handleCallback(model);
                  }}
                  key={m.streamName}
                ></ItemGrid>
              ))}
            </div>
            {showLoadMore && <LoadMore />}
          </div>
        ) : (
          <div
            className="flex flex-col flex-1 mt-2 pt-2 gap-2 overflow-y-auto pb-6 my-scrollbar pl-6 pr-3 mr-1.5"
            onScroll={(e) => {
              onListScroll(e);
            }}
          >
            {list.map((m) => (
              <ItemStrip
                isDeleted={m.isDeleted || m.subscribed === false}
                model={m}
                deleteCallback={() => {
                  deleteCallback(m.streamName);
                }}
                cancelCollectCallback={(model) => {
                  cancelCollectCallback(model);
                }}
                handleCallback={(model) => {
                  handleCallback(model);
                }}
                key={m.streamName}
              ></ItemStrip>
            ))}
            {showLoadMore && <LoadMore />}
          </div>
        ))}
    </div>
  );
}
